import type { ReactNode } from "react";
import { cn } from "@/utils/cn";

interface FeatureChipProps {
  name: string;
  period: number;
  period2?: number;
  icon: ReactNode | null;
  color: string;
}

export function FeatureChip({
  name,
  period,
  period2,
  icon,
  color,
}: FeatureChipProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-2 px-3 py-2 rounded-lg",
        "bg-dark-800/50 border border-dark-700",
        "transition-colors hover:bg-dark-700/50"
      )}
    >
      {icon && (
        <div className={cn("p-1.5 rounded-md bg-gradient-to-r", color)}>
          {icon}
        </div>
      )}
      <div className="flex flex-col min-w-0">
        <span className="text-sm font-medium text-foreground truncate">
          {name}
        </span>
        <span className="text-xs text-muted-foreground">
          {period2 ? `${period} / ${period2}` : period}
        </span>
      </div>
    </div>
  );
}
